// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".recommended-text[data-v-02272efc] {\n  color: #2f99a3;\n  font-style: italic;\n}\n.maintenance-window-width[data-v-02272efc] {\n  width: 330px !important;\n}\n.tech-position[data-v-02272efc] {\n  position: absolute;\n}", ""]);
// Exports
module.exports = exports;
